<template>
  <b-server-table
    :key="tableRenderKey"
    :filter-props="{
      filterMap: [{ key: 'search' }],
    }"
    :headers="orgDirectoryHeaders"
    :request-func="getItems">
    <template #action-button>
      <v-btn @click="openCreateDialog">
        <v-icon class="mr-1">mdi-plus</v-icon>
        <span>Створити підрозділ</span>
      </v-btn>
    </template>
    <template #item.name="{ item }">
      {{ item?.name || '---' }}
    </template>
    <template #item.description="{ item }">
      {{ item?.description || '---' }}
    </template>
    <template #item.actions="{ item }">
      <b-action-menu
        :actions="[
          {
            title: 'Редагувати',
            action: () => openUpdateDialog(item),
            icon: 'mdi-pencil',
            iconProps: {
              color: 'blue-darken-3',
            },
          },
          {
            title: 'Видалити',
            action: () => deleteItem(item.id),
            icon: 'mdi-delete-forever',
            listItemProps: {
              class: 'text-error',
            },
            iconProps: {
              color: 'error',
            },
          },
        ]">
      </b-action-menu>
    </template>
  </b-server-table>
</template>
<script lang="ts">
import { ref } from 'vue'
import { axios } from '@/plugins'
import {
  urlCreateOrgDepartmentType,
  urlDeleteOrgDepartmentType,
  urlGetOrgDepartmentTypes,
  urlUpdateOrgDepartmentType,
} from '@/utils/urls'
import { openDialog } from '@/dialog'
import { orgDirectoryHeaders } from '@/utils/tableHeaders'
import { BServerTable } from 'best-modules/components/index'
import { Query } from 'best-modules/utils'

type OrgDirectoryItem = {
  id: number
  name: string
  description?: string | null
}

export default {
  name: 'OrgDepartmentTypeList',
  components: { BServerTable },
  data: () => {
    return {
      orgDirectoryHeaders,
    }
  },
  setup() {
    const tableRenderKey = ref(1)

    const getItems = (query: Query) => {
      return axios
        .get(urlGetOrgDepartmentTypes({ ...query, paginate: true }))
        .then(res => res.data)
    }

    const entityConfig = {
      label: 'Тип підрозділу',
      hasDescription: true,
      directoryName: 'orgDepartmentTypes',
      urlCreate: urlCreateOrgDepartmentType,
      urlUpdate: urlUpdateOrgDepartmentType,
    }

    const openCreateDialog = () => {
      openDialog({
        name: 'OrgDirectoryItem',
        action: 'create',
        params: {
          title: 'Створити тип підрозділу',
          submitLabel: 'Створити',
          cb: () => (tableRenderKey.value += 1),
        },
        dialogData: { entityConfig },
      })
    }

    const openUpdateDialog = (item: OrgDirectoryItem) => {
      openDialog({
        name: 'OrgDirectoryItem',
        action: 'update',
        params: {
          title: 'Редагувати тип підрозділу',
          submitLabel: 'Змінити',
          cb: () => (tableRenderKey.value += 1),
        },
        dialogData: { entityConfig, itemData: item },
      })
    }

    const deleteItem = (id: number) => {
      return axios.delete(urlDeleteOrgDepartmentType(id)).then(() => {
        tableRenderKey.value += 1
      })
    }

    return {
      getItems,
      openCreateDialog,
      openUpdateDialog,
      deleteItem,
      tableRenderKey,
    }
  },
}
</script>
